<template>
    <div
        class="mb-2 ml-4 text-[13px] font-semibold tracking-wider text-gray-925 lg:text-white/60"
    >
        GENERAL
    </div>
    <ul class="mb-8">
        <Link
            as="li"
            :href="route('student.dashboard')"
            :class="linkCss(['student.dashboard'])"
        >
            <div>Dashboard</div>
        </Link>
        <Link
            as="li"
            :href="route('student.live-events.index')"
            :class="linkCss(['student.live-events'])"
        >
            <div class="flex w-full items-center justify-between">
                <div>Live Webinars</div>
                <div
                    v-if="$page.props.liveWebinar"
                    class="rounded bg-red-500 px-2 py-1 text-[16px] text-white"
                >
                    Live Now
                </div>
            </div>
        </Link>
        <Link
            as="li"
            :href="route('student.computer-adaptive-test.index')"
            :class="linkCss(['student.computer-adaptive-test'])"
        >
            <div>Computer Adaptive Test</div>
        </Link>
    </ul>

    <div
        class="mb-2 ml-4 text-[13px] font-semibold tracking-wider text-gray-925 lg:text-white/60"
    >
        ALL RESOURCES
    </div>
    <ul class="mb-8">
        <Link
            as="li"
            :href="route('student.quizzes.index')"
            :class="linkCss(['student.quizzes', 'student.quiz'])"
        >
            <div>Quizzes</div>
        </Link>
        <Link
            as="li"
            :href="route('student.flashcards.index')"
            :class="linkCss(['student.flashcards'])"
        >
            <div>Flashcards</div>
        </Link>
        <Link
            as="li"
            :href="route('student.worksheets.index')"
            :class="linkCss(['student.worksheets'])"
        >
            <div>Interactive Exercises</div>
        </Link>
        <Link
            as="li"
            :href="route('student.study-guides.index')"
            :class="linkCss(['student.study-guides'])"
        >
            <div>Study Guides</div>
        </Link>
        <Link
            as="li"
            :href="route('student.videos.index')"
            :class="linkCss(['student.videos'])"
        >
            <div>Videos</div>
        </Link>
    </ul>
    <div
        class="flex items-center justify-between border-b border-t border-gray-925/30 px-4 py-3 text-gray-925 hover:cursor-pointer hover:bg-gray-825/5 lg:border-white/30 lg:text-white/60 lg:hover:bg-white/5"
        @click="toggleFocusAreas()"
    >
        <div class="text-[13px] font-semibold tracking-wider">
            FOCUS AREAS ({{ $page.props.focusAreas.length }})
        </div>
        <div class="" v-if="!showFocusAreas">
            <svg
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 1L7 7L13 1"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
        <div class="" v-else>
            <svg
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1 7L7 1L13 7"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </div>
    </div>
    <transition name="list">
        <div class="" v-if="showFocusAreas">
            <ul>
                <Link
                    v-for="focusArea in $page.props.focusAreas"
                    as="li"
                    :href="
                        route('student.focus-area.index', {
                            focus_area: focusArea.id,
                        })
                    "
                    :class="
                        linkCss(['student.focus-area.index'], {
                            focus_area: focusArea.id,
                        })
                    "
                >
                    <div>{{ focusArea.title }}</div>
                </Link>
            </ul>
        </div>
    </transition>
    <div
        :class="
            'mt-2' + ' ' + (showFocusAreas ? 'border-t border-white/30' : '')
        "
    >
        <StudentQuestionOfTheDayModal
            :student-question-of-the-day="$page.props.studentQuestionOfTheDay"
        />
    </div>
    <!-- forcing tailwind jit to compile these styles-->
    <div
        class="hidden border-l-teal-400 border-r-teal-400 border-r-transparent bg-teal-400/10 text-white/60"
    ></div>
</template>
<script>
import StudentQuestionOfTheDayModal from "@/Components/StudentQuestionOfTheDayModal.vue";

export default {
    name: "StudentSidebarNavigation",
    components: { StudentQuestionOfTheDayModal },
    data() {
        return {
            showFocusAreas: false,
        };
    },
    methods: {
        toggleFocusAreas() {
            this.showFocusAreas = !this.showFocusAreas;

            localStorage.setItem("showFocusAreas", this.showFocusAreas);
        },
        linkCss(activeRoutes, optionalParams) {
            let linkCss =
                "text-[16px] leading-0 flex items-center gap-2  lg:border-r-[5px] px-4 py-2 text-gray-925 lg:text-white hover:cursor-pointer hover:bg-white/5" +
                " " +
                (this.isActive(activeRoutes, optionalParams)
                    ? "lg:border-r-teal-400 bg-gray-925/10 lg:bg-white/10"
                    : "border-transparent lg:border-transparent");

            return linkCss;
        },
        isActive(activeRoutes, optionalParams) {
            return _.find(activeRoutes, function (activeRoute) {
                if (optionalParams) {
                    return route().current(activeRoute, optionalParams);
                } else {
                    return _.startsWith(route().current(), activeRoute);
                }
            });
        },
    },
    mounted() {
        this.showFocusAreas = localStorage.getItem("showFocusAreas") === "true";
    },
};
</script>

<style>
.list-enter-active,
.list-leave-active {
    transition: opacity 0.12s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
}
</style>
